import { render, staticRenderFns } from "./ParametreEdit.vue?vue&type=template&id=87fda822&"
import script from "./ParametreEdit.vue?vue&type=script&lang=js&"
export * from "./ParametreEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87fda822')) {
      api.createRecord('87fda822', component.options)
    } else {
      api.reload('87fda822', component.options)
    }
    module.hot.accept("./ParametreEdit.vue?vue&type=template&id=87fda822&", function () {
      api.rerender('87fda822', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/parametre/ParametreEdit.vue"
export default component.exports